export function FormulaCard({
  label,
  isActive,
  formulaText,
  substitution,
  result,
  color,
}: Readonly<{
  label: string
  isActive: boolean
  formulaText: string
  substitution?: string
  result?: number
  color: string
}>) {
  const borderColor = isActive ? color : '#e9eaeb'
  const bgColor = isActive ? `${color}10` : '#f9fafb'
  const resultColor = isActive ? color : '#9ca3af'

  return (
    <div
      className="rounded-xl p-3 border transition-all"
      style={{ borderColor, backgroundColor: bgColor }}
    >
      <div className="flex items-center justify-between mb-2">
        <span
          className="text-xs font-semibold uppercase tracking-wider px-2 py-0.5 rounded-full border"
          style={{ color, borderColor: `${color}40`, backgroundColor: `${color}15` }}
        >
          {label}
        </span>
        {result !== undefined && (
          <span className="text-base font-semibold" style={{ color: resultColor }}>
            {result}
          </span>
        )}
      </div>
      <p className="text-2xs text-muted-foreground font-mono mb-1">{formulaText}</p>
      {substitution && <p className="text-2xs text-foreground/70 font-mono">{substitution}</p>}
    </div>
  )
}
